export default __webpack_public_path__ + "static/media/client_console.f823ae68.png";